// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_tG0","question":"styles_question__2voHY","description":"styles_description__SqpTA"};